/* ===========================================================================
   APEXTIDES theme — progressive enhancement.
   Every interaction has a no-JS fallback (real links, real form posts).
   This file adds: sticky-header state, mobile nav, scroll reveals, animated
   metrics, accordions, modals, the age gate, toasts, and an AJAX cart drawer
   backed by Shopify's own /cart/*.js endpoints + Section Rendering API.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.APEXTIDES || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---- Focus trap --------------------------------------------------------
     Used by the age gate and the cart drawer. Both cover the page, so Tab must
     not walk into the content behind them. Returns a release function. */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function visibleFocusable(container) {
    return $$(FOCUSABLE, container).filter(function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  function trapFocus(container, initial) {
    var previouslyFocused = document.activeElement;
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var f = visibleFocusable(container);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!container.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', onKey);
    var target = initial || visibleFocusable(container)[0];
    if (target) target.focus();
    return function release(restore) {
      document.removeEventListener('keydown', onKey);
      if (restore !== false && previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }

  /* ---- Sticky header state --------------------------------------------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile nav ------------------------------------------------------- */
  var menuToggle = $('[data-menu-toggle]');
  var mobileNav = $('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Header search ---------------------------------------------------- */
  var searchToggle = $('[data-search-toggle]');
  var searchBox = $('[data-header-search]');
  if (searchToggle && searchBox) {
    searchToggle.addEventListener('click', function () {
      var open = searchBox.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input[type="search"]', searchBox); if (i) i.focus(); }
    });
  }

  /* ---- Scroll reveals --------------------------------------------------- */
  var reveals = $$('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('in');
          io.unobserve(e.target);
          if (e.target.querySelector('[data-to]')) animateMetrics(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- Animated metric counters ---------------------------------------- */
  function animateMetrics(scope) {
    $$('[data-to]', scope).forEach(function (el) {
      if (el.dataset.done) return;
      el.dataset.done = '1';
      var to = parseFloat(el.dataset.to);
      var bar0 = el.parentElement && el.parentElement.querySelector('.metric__bar i');
      if (bar0 && el.dataset.bar) setTimeout(function () { bar0.style.width = el.dataset.bar + '%'; }, 60);
      // Non-numeric claims (e.g. "COA") are already correct in the markup.
      if (isNaN(to)) return;
      var pre = el.dataset.pre || '';
      var suf = el.dataset.suf || '';
      var decimals = (el.dataset.to.split('.')[1] || '').length;
      var start = null;
      var dur = 1300;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + (to * eased).toFixed(decimals) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      var bar = el.parentElement && el.parentElement.querySelector('.metric__bar i');
      if (bar && el.dataset.bar) setTimeout(function () { bar.style.width = el.dataset.bar + '%'; }, 60);
    });
  }
  // Metrics already in view on load still animate.
  $$('.metric').forEach(function (m) {
    var r = m.getBoundingClientRect();
    if (r.top < window.innerHeight) animateMetrics(m);
  });

  /* ---- Accordions ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc__head');
    if (!head) return;
    var item = head.closest('.acc__item');
    var panel = $('.acc__panel', item);
    var open = item.classList.toggle('open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  });

  /* ---- Generic modals --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var m = $(opener.getAttribute('data-modal-open'));
      if (m) m.hidden = false;
      return;
    }
    if (e.target.closest('[data-modal-close]') || e.target.matches('.modal__backdrop')) {
      var open = e.target.closest('.modal');
      if (open) open.hidden = true;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.modal').forEach(function (m) { m.hidden = true; });
    closeDrawer();
  });

  /* ---- Age verification gate -------------------------------------------- */
  var AGE_KEY = 'apex_age_verified';
  var gate = $('[data-age-gate]');
  if (gate) {
    var verified = false;
    try { verified = localStorage.getItem(AGE_KEY) === 'true'; } catch (err) {}
    if (!verified) {
      gate.hidden = false;
      gate.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var yes = $('[data-age-yes]', gate);
      var no = $('[data-age-no]', gate);
      var pending = $('[data-age-pending]', gate);
      var denied = $('[data-age-denied]', gate);
      var releaseGate = trapFocus(gate, yes);
      if (yes) yes.addEventListener('click', function () {
        try { localStorage.setItem(AGE_KEY, 'true'); } catch (err) {}
        releaseGate(false);
        gate.hidden = true;
        gate.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        /* Focus must leave the dismissed dialog, but not onto .skip-link:
           that link is visible-on-focus by design, so focusing it leaves a
           stray "Skip to content" button on screen. Send it to the content. */
        var main = document.getElementById('MainContent');
        if (main) main.focus();
      });
      if (no) no.addEventListener('click', function () {
        if (pending) pending.hidden = true;
        if (denied) denied.hidden = false;
        // Re-trap on the denied panel, which replaces the buttons.
        releaseGate(false);
        releaseGate = trapFocus(gate);
      });
    }
  }

  /* ---- Toast ------------------------------------------------------------ */
  var toastEl = $('#Toast');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    var text = $('[data-toast-text]', toastEl);
    if (text) text.textContent = message;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---- Added-to-cart banner --------------------------------------------- */
  var note = $('[data-cart-note]');
  var noteTimer;

  /* Liquid's `t` filter HTML-escapes its output, and textContent does not
     decode entities — so a quote or apostrophe in a locale string would render
     as &quot; / &#39;. Decode the few entities `t` emits, by hand rather than
     via innerHTML, which would reintroduce an injection path. */
  function decodeEntities(str) {
    return String(str)
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }

  function showCartNote(productTitle) {
    if (!note) return;
    var text = $('[data-cart-note-text]', note);
    if (text) {
      var tpl = decodeEntities(CFG.strings.added_to_cart || '“[product]” has been added to your cart.');
      text.textContent = tpl.replace('[product]', productTitle || '');
    }
    note.hidden = false;
    // Other sticky elements (catalogue toolbar, PDP gallery) stick below the
    // banner rather than underneath it.
    document.documentElement.style.setProperty('--cart-note-h', note.offsetHeight + 'px');
    clearTimeout(noteTimer);
  }
  function hideCartNote() {
    if (!note) return;
    note.hidden = true;
    document.documentElement.style.setProperty('--cart-note-h', '0px');
  }

  if (note) {
    note.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-note-close]')) hideCartNote();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideCartNote(); });
  }

  /* ---- Cart drawer ------------------------------------------------------ */
  var drawer = $('[data-cart-drawer]');
  var scrim = $('[data-drawer-scrim]');

  var releaseDrawer = null;

  function openDrawer() {
    if (!drawer || drawer.classList.contains('open')) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('open'); }); }
    document.body.style.overflow = 'hidden';
    // Wait for the visibility transition before moving focus into the panel.
    setTimeout(function () { releaseDrawer = trapFocus(drawer, $('[data-drawer-close]', drawer)); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('open'); setTimeout(function () { scrim.hidden = true; }, 350); }
    document.body.style.overflow = '';
    if (releaseDrawer) { releaseDrawer(); releaseDrawer = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) { closeDrawer(); return; }
    var opener = e.target.closest('[data-drawer-open]');
    if (opener && drawer) { e.preventDefault(); openDrawer(); }
  });

  function setCartCount(count) {
    /* The board's header shows "Cart · 0" rather than a badge that appears on
       first add, so the count is always rendered. */
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var dc = $('[data-drawer-count]');
    if (dc) dc.textContent = '(' + count + ')';
  }

  /* Refresh the drawer from the server so prices/discounts stay authoritative. */
  function refreshDrawer() {
    return fetch(CFG.routes.cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = $('[data-drawer-body]');
        var newBody = $('[data-drawer-body]', doc);
        if (body && newBody) body.innerHTML = newBody.innerHTML;

        var foot = $('[data-drawer-foot]');
        var newFoot = $('[data-drawer-foot]', doc);
        if (foot && newFoot) { foot.innerHTML = newFoot.innerHTML; foot.hidden = newFoot.hidden; }

        var count = $('[data-drawer-count]', doc);
        if (count) {
          var n = parseInt(count.textContent.replace(/\D/g, ''), 10) || 0;
          setCartCount(n);
        }
      })
      .catch(function () {});
  }

  /* ---- AJAX add to cart -------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = CFG.strings.adding; }

    fetch(CFG.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (item) {
        return refreshDrawer().then(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          var mode = CFG.addToCartBehavior || 'drawer';
          var title = item && item.product_title;
          // One confirmation, not three: the banner replaces the toast.
          if (mode === 'banner' || mode === 'both') showCartNote(title);
          if (mode === 'drawer' || mode === 'both') openDrawer();
          if (mode === 'drawer') toast((title ? title + ' — ' : '') + CFG.strings.added);
        });
      })
      .catch(function () { form.submit(); });
  });

  /* ---- BAC water pre-checkout upsell ------------------------------------
     One dialog serves both the drawer and the cart page. Whether to show it is
     decided from live /cart.js state at click time, never from a Liquid flag —
     the drawer re-renders after every mutation, so a render-time flag is stale
     the moment an item is added or removed.

     Proceeding re-submits with an explicit `checkout` field: form.submit()
     does not carry the submit button's name, so posting without it would just
     update the cart and bounce back instead of reaching checkout. */
  (function () {
    var bacModal = $('[data-bac-modal]');
    if (!bacModal) return;

    var pendingForm = null;
    var release = null;

    function isCheckoutSubmit(e) {
      var b = e.submitter || document.activeElement;
      return !!(b && b.name === 'checkout');
    }

    function closeBac() {
      bacModal.hidden = true;
      if (release) { release(true); release = null; }
    }

    /* Post the form the way the checkout button would have. Re-renders can
       detach the form we captured, and submit() on a detached form silently
       does nothing — so fall back to whichever checkout form is live now. */
    function goCheckout(form) {
      if (!form || !form.isConnected) {
        var live = document.querySelector('[data-drawer-foot] form [name="checkout"]');
        form = live ? live.form : document.querySelector('[data-checkout-form]');
      }
      if (!form) { window.location.href = CFG.routes.cart; return; }
      if (!form.querySelector('input[name="checkout"]')) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '';
        form.appendChild(hidden);
      }
      form.submit();
    }

    function proceed() {
      var form = pendingForm;
      pendingForm = null;
      closeBac();
      goCheckout(form);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.hasAttribute('data-bac-answered')) return;
      if (!isCheckoutSubmit(e)) return;

      e.preventDefault();
      fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var hasBac = items.some(function (i) { return i.handle === CFG.bacHandle; });
          form.setAttribute('data-bac-answered', '');
          /* Nothing to reconstitute (and Shopify rejects an empty checkout),
             so never interrupt an empty cart. */
          if (!items.length || hasBac) { goCheckout(form); return; }
          pendingForm = form;
          bacModal.hidden = false;
          release = trapFocus(bacModal.querySelector('.modal__panel'));
        })
        /* Never trap the customer behind a failed request. */
        .catch(function () { form.setAttribute('data-bac-answered', ''); goCheckout(form); });
    });

    bacModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bac-skip]')) { proceed(); return; }

      var addBtn = e.target.closest('[data-bac-add]');
      if (!addBtn) return;

      var original = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.textContent = CFG.strings.adding;

      fetch(CFG.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: addBtn.getAttribute('data-variant'), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(proceed)
        /* Sold out or gone: say so, and still let them check out. */
        .catch(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          toast(CFG.strings.bac_unavailable);
          proceed();
        });
    });

    /* Dismissing the dialog cancels checkout rather than silently continuing. */
    bacModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]') || e.target.matches('.modal__backdrop')) {
        pendingForm = null;
        closeBac();
      }
    });
  })();

  function serialize(form) {
    var data = { quantity: 1 };
    $$('input, select, textarea', form).forEach(function (input) {
      if (!input.name || input.disabled) return;
      if (input.type === 'radio' && !input.checked) return;
      if (input.name === 'id') data.id = input.value;
      else if (input.name === 'quantity') data.quantity = parseInt(input.value, 10) || 1;
      else {
        var m = input.name.match(/properties\[(.+)\]/);
        if (m) { data.properties = data.properties || {}; data.properties[m[1]] = input.value; }
      }
    });
    return data;
  }

  /* ---- Drawer line quantity + remove ------------------------------------ */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    var rmBtn = e.target.closest('[data-cart-remove]');
    if (!qtyBtn && !rmBtn) return;
    e.preventDefault();

    var line = qtyBtn ? qtyBtn.getAttribute('data-cart-qty') : rmBtn.getAttribute('data-cart-remove');
    var quantity = qtyBtn ? parseInt(qtyBtn.getAttribute('data-to'), 10) : 0;
    if (quantity < 0) quantity = 0;

    if (drawer) drawer.style.opacity = '.55';
    fetch(CFG.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refreshDrawer(); })
      .then(function () { if (drawer) drawer.style.opacity = ''; })
      .catch(function () { window.location.href = CFG.routes.cart; });
  });

  /* ---- Share cart (native permalink) ------------------------------------ */
  document.addEventListener('click', function (e) {
    var shareBtn = e.target.closest('[data-share-cart]');
    if (!shareBtn) return;
    var url = shareBtn.getAttribute('data-url');
    if (navigator.share) {
      navigator.share({ title: shareBtn.dataset.shareTitle, text: shareBtn.dataset.shareText, url: url }).catch(function () {});
      return;
    }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
      .then(function () { toast(shareBtn.dataset.labelCopied || 'Copied'); })
      .catch(function () { window.prompt('Copy your cart link:', url); });
  });

  /* ---- Product card size pills ------------------------------------------
     Switching a size on the card updates the price and the variant the form
     will post, so a shopper can add the right one without opening the PDP. */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-card-variant]');
    if (!pill) return;
    var card = pill.closest('[data-product-card]');
    if (!card) return;

    $$('[data-card-variant]', card).forEach(function (p) { p.setAttribute('aria-pressed', String(p === pill)); });

    var price = $('[data-card-price]', card);
    if (price) price.textContent = pill.getAttribute('data-price');

    var input = $('[data-card-variant-input]', card);
    if (input) input.value = pill.getAttribute('data-card-variant');

    var available = !pill.hasAttribute('data-unavailable');
    var submit = card.querySelector('[data-cart-add] button[type="submit"]');
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? CFG.strings.add_to_cart : CFG.strings.sold_out;
    }
    var stock = $('[data-card-stock]', card);
    if (stock) {
      stock.textContent = available ? CFG.strings.in_stock : CFG.strings.out_of_stock;
      stock.classList.toggle('product-card__stock--out', !available);
    }
  });

  /* ---- Quantity steppers (PDP / cart page) ------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('.stepper') || btn.parentElement;
    var input = wrap && wrap.querySelector('input[name="quantity"], [data-qty]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    input.value = btn.hasAttribute('data-qty-plus') ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Tab pills (Explore panel) ---------------------------------------
     Roving tabindex: only the selected tab is in the tab order, arrows move
     between them. That is the ARIA tabs pattern browsers and screen readers
     expect, and it keeps Tab moving on to the panel content. */
  function selectTab(list, tab) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tabs] [role="tab"]');
    if (tab) selectTab(tab.closest('[data-tabs]'), tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-tabs] [role="tab"]');
    if (!tab) return;
    var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!dir) return;
    e.preventDefault();
    var list = tab.closest('[data-tabs]');
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var next = tabs[(tabs.indexOf(tab) + dir + tabs.length) % tabs.length];
    selectTab(list, next);
    next.focus();
  });

  /* ---- Announcement height ---------------------------------------------
     The header group is pinned at minus this value, so the claims bar scrolls
     away and the nav lands flush at the top. Measured rather than hard-coded
     because the bar wraps at narrow widths. */
  /* ---- Language switch also moves the market ------------------------------
     Language is the only control; the market rides along with it. Click fires
     before submit, so setting the hidden field here is in time. Options without
     a data-country post the current country unchanged — a valid no-op rather
     than an empty value. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="locale_code"][data-country]');
    if (!btn) return;
    var form = btn.closest('form');
    var field = form && form.querySelector('[data-country-field]');
    if (field) field.value = btn.getAttribute('data-country');
  });

  /* ---- Nav dropdowns -----------------------------------------------------
     Hover and focus-within are handled in CSS. This adds the touch case,
     where there is no hover: the first tap opens, a tap outside closes. */
  (function () {
    var groups = $$('[data-nav-group]');
    if (!groups.length) return;

    function closeAll(except) {
      groups.forEach(function (g) {
        if (g === except) return;
        g.classList.remove('is-open');
        var t = $('.nav-group__toggle', g);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    groups.forEach(function (g) {
      var toggle = $('.nav-group__toggle', g);
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = g.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeAll(g);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-group]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();

  /* ---- Announcement rotator ---------------------------------------------
     Pauses on hover, on keyboard focus, and when the tab is hidden — a banner
     that keeps cycling in a background tab is wasted work. Honours
     prefers-reduced-motion by not auto-advancing at all. */
  $$('[data-announcement-rotator]').forEach(function (rot) {
    var items = $$('.announcement__item', rot);
    if (items.length < 2) return;

    var wait = parseInt(rot.getAttribute('data-interval'), 10) || 4000;
    var idx = 0;
    var timer = null;

    function show(next) {
      items[idx].classList.remove('is-active');
      idx = (next + items.length) % items.length;
      items[idx].classList.add('is-active');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      timer = setInterval(function () { show(idx + 1); }, wait);
    }

    rot.addEventListener('mouseenter', stop);
    rot.addEventListener('mouseleave', start);
    rot.addEventListener('focusin', stop);
    rot.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) start();
  });

  (function measureAnnouncement() {
    var ann = document.querySelector('.announcement');
    if (!ann) return;
    var set = function () {
      document.documentElement.style.setProperty('--ann-h', ann.offsetHeight + 'px');
    };
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(ann);
    else window.addEventListener('resize', set);
  })();

  window.APEXTIDES.trapFocus = trapFocus;
  window.APEXTIDES.toast = toast;
  window.APEXTIDES.openDrawer = openDrawer;
  window.APEXTIDES.refreshDrawer = refreshDrawer;
})();
